import React from 'react';

const Games = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 41 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40.2987 37.9133C40.2987 36.6517 39.2746 35.6276 38.013 35.6276H32.8855V31.9854C32.8855 29.91 31.1967 28.2144 29.1145 28.2144H22.5083V16.1552L22.9628 15.9924C26.2387 14.8326 28.443 11.7194 28.443 8.25359C28.443 3.72291 24.7601 0.0400391 20.2294 0.0400391C15.6988 0.0400391 12.0159 3.72291 12.0159 8.25359C12.0159 11.7194 14.2202 14.8258 17.4961 15.9924L17.9505 16.1552V28.2076H11.3444C9.26899 28.2076 7.57338 29.8964 7.57338 31.9786V35.6208H2.44584C1.18431 35.6208 0.160156 36.6449 0.160156 37.9065V47.6743C0.160156 48.9359 1.18431 49.96 2.44584 49.96H38.013C39.2746 49.96 40.2987 48.9359 40.2987 47.6743V37.9133ZM15.0951 8.26037C15.0951 5.43209 17.3944 3.13284 20.2227 3.13284C23.0509 3.13284 25.3502 5.43209 25.3502 8.26037C25.3502 11.0887 23.0509 13.3879 20.2227 13.3879C17.3944 13.3879 15.0951 11.0887 15.0951 8.26037ZM11.9326 32.5804H28.5195V35.6208H11.9326V32.5804ZM35.9259 45.594H4.51261V39.9936H35.9259V45.594Z"
      fill="#9B9B9B"
    />
  </svg>
);
const Points = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M47.29 3.04004H41.54V0.540039C41.54 0.265039 41.315 0.0400391 41.04 0.0400391H9.04004C8.76504 0.0400391 8.54004 0.265039 8.54004 0.540039V3.04004H2.79004C2.06069 3.04004 1.36122 3.32977 0.845495 3.8455C0.32977 4.36122 0.0400391 5.06069 0.0400391 5.79004V15.04C0.0400391 20.1463 3.79004 24.39 8.67754 25.165C9.64629 32.4275 15.4775 38.1463 22.79 38.9463V45.5213H10.54C9.43379 45.5213 8.54004 46.415 8.54004 47.5213V49.54C8.54004 49.815 8.76504 50.04 9.04004 50.04H41.04C41.315 50.04 41.54 49.815 41.54 49.54V47.5213C41.54 46.415 40.6463 45.5213 39.54 45.5213H27.29V38.9463C34.6025 38.1463 40.4338 32.4275 41.4025 25.165C46.29 24.39 50.04 20.1463 50.04 15.04V5.79004C50.04 5.06069 49.7503 4.36122 49.2346 3.8455C48.7189 3.32977 48.0194 3.04004 47.29 3.04004ZM8.54004 20.515C7.37908 20.1442 6.366 19.414 5.64703 18.43C4.92806 17.4459 4.54041 16.2588 4.54004 15.04V7.54004H8.54004V20.515ZM37.04 23.04C37.04 26.1088 35.8463 29.0025 33.6713 31.1713C31.4963 33.3463 28.6088 34.54 25.54 34.54H24.54C21.4713 34.54 18.5775 33.3463 16.4088 31.1713C14.2338 28.9963 13.04 26.1088 13.04 23.04V4.54004H37.04V23.04ZM45.54 15.04C45.54 17.6025 43.8588 19.7775 41.54 20.515V7.54004H45.54V15.04Z"
      fill="#9B9B9B"
    />
  </svg>
);
const Quest = props => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 7.5H49.506L41.6532 20.0889L49.6323 32.2407H16.5V51H11.5V7.5ZM16.5 27.2407H40.3677L35.7171 20.158L40.494 12.5H16.5V27.2407Z"
      fill="#8C8C8C"
    />
  </svg>
);
const Progress = props => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10H47.9006L41.7226 20.129L48 29.9063H21.9337V36H18L18 10ZM21.9337 25.8834H40.7112L37.0525 20.1846L40.8106 14.023H21.9337V25.8834Z"
      fill="#8C8C8C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.9495 42H53.5C54.8807 42 56 43.1193 56 44.5C56 45.8807 54.8807 47 53.5 47H28.9495C29.5978 46.3647 30 45.4793 30 44.5C30 43.5207 29.5978 42.6353 28.9495 42ZM1 44.5C1 41.4624 3.46243 39 6.5 39H53.5C56.5376 39 59 41.4624 59 44.5C59 47.5376 56.5376 50 53.5 50H6.5C3.46243 50 1 47.5376 1 44.5Z"
      fill="#8C8C8C"
    />
  </svg>
);
const Quiz = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 52 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2027 1.42734L43.6527 14.8773C44.0277 15.2523 44.2402 15.7648 44.2402 16.2961V28.2471L39.7402 32.7387V21.4648H26.2402C25.544 21.4648 24.8764 21.1883 24.3841 20.696C23.8918 20.2037 23.6152 19.536 23.6152 18.8398V5.33984H4.74023V52.3398H22.9948L22.9229 56.8398H2.24023C1.13398 56.8398 0.240234 55.9461 0.240234 54.8398V2.83984C0.240234 1.73359 1.13398 0.839844 2.24023 0.839844H28.7902C29.3215 0.839844 29.8277 1.05234 30.2027 1.42734ZM39.6277 17.2148L27.8652 5.45234V17.2148H39.6277Z"
      fill="#8C8C8C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.2896 50.8068L25.2003 56.398C25.1956 56.8166 25.5341 57.1598 25.9526 57.1598H25.9715L31.5202 57.0235C31.6142 57.0188 31.7082 56.9811 31.7741 56.9153L51.3309 37.3999C51.4767 37.2541 51.4767 37.0143 51.3309 36.8685L45.486 31.028C45.4107 30.9528 45.3167 30.9198 45.2179 30.9198C45.1192 30.9198 45.0251 30.9575 44.9499 31.028L25.3978 50.5434C25.3299 50.6144 25.2912 50.7085 25.2896 50.8068ZM28.2756 51.9165L45.2179 35.011L47.3434 37.1319L30.3916 54.0468L28.2427 54.0985L28.2756 51.9165Z"
      fill="#8C8C8C"
    />
  </svg>
);
const Referral = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M48.7503 42.2505H43.7503V37.2505C43.7503 36.9755 43.5253 36.7505 43.2503 36.7505H40.2503C39.9753 36.7505 39.7503 36.9755 39.7503 37.2505V42.2505H34.7503C34.4753 42.2505 34.2503 42.4755 34.2503 42.7505V45.7505C34.2503 46.0255 34.4753 46.2505 34.7503 46.2505H39.7503V51.2505C39.7503 51.5255 39.9753 51.7505 40.2503 51.7505H43.2503C43.5253 51.7505 43.7503 51.5255 43.7503 51.2505V46.2505H48.7503C49.0253 46.2505 49.2503 46.0255 49.2503 45.7505V42.7505C49.2503 42.4755 49.0253 42.2505 48.7503 42.2505ZM16.344 25.1505C16.2878 24.6067 16.2565 24.0567 16.2565 23.5005C16.2565 22.5067 16.3503 21.538 16.5253 20.5942C16.569 20.3692 16.4503 20.138 16.244 20.0442C15.394 19.663 14.6128 19.138 13.9378 18.4755C13.1424 17.7043 12.5165 16.7758 12.1 15.7491C11.6836 14.7225 11.4857 13.6204 11.519 12.513C11.5753 10.5067 12.3815 8.60049 13.7878 7.16299C15.3315 5.58174 17.4065 4.71924 19.6128 4.74424C21.6065 4.76299 23.5315 5.53174 24.9878 6.89424C25.4815 7.35674 25.9065 7.86924 26.2628 8.41924C26.3878 8.61299 26.6315 8.69424 26.844 8.61924C27.944 8.23799 29.1065 7.96924 30.3003 7.84424C30.6503 7.80674 30.8503 7.43174 30.694 7.11924C28.6628 3.10049 24.5128 0.32549 19.7128 0.25049C12.7878 0.14424 7.01275 5.82549 7.01275 12.7505C7.01275 16.6755 8.819 20.1755 11.6503 22.4692C9.66275 23.388 7.8315 24.6567 6.244 26.2442C2.819 29.663 0.881504 34.1755 0.756504 38.9942C0.754836 39.0609 0.766536 39.1273 0.790916 39.1894C0.815295 39.2515 0.85186 39.3081 0.898457 39.3559C0.945053 39.4037 1.00074 39.4416 1.06223 39.4675C1.12372 39.4934 1.18978 39.5068 1.2565 39.5067H4.76275C5.0315 39.5067 5.2565 39.2942 5.26275 39.0255C5.3815 35.4005 6.85025 32.0067 9.4315 29.4317C11.269 27.5942 13.519 26.3192 15.9753 25.7005C16.2128 25.6317 16.3753 25.4005 16.344 25.1505ZM44.5003 23.5005C44.5003 16.663 39.0065 11.1067 32.194 11.0005C25.269 10.8942 19.5003 16.5755 19.5003 23.5005C19.5003 27.4255 21.3128 30.9255 24.1378 33.2192C22.1297 34.1501 20.3016 35.428 18.7378 36.9942C15.3128 40.413 13.3753 44.9255 13.2503 49.738C13.2486 49.8047 13.2603 49.8711 13.2847 49.9332C13.309 49.9953 13.3456 50.0519 13.3922 50.0997C13.4388 50.1474 13.4945 50.1854 13.556 50.2113C13.6175 50.2372 13.6835 50.2505 13.7503 50.2505H17.2503C17.519 50.2505 17.744 50.038 17.7503 49.7692C17.869 46.1442 19.3378 42.7505 21.919 40.1755C24.6128 37.4817 28.1878 36.0005 32.0003 36.0005C38.9003 36.0005 44.5003 30.4067 44.5003 23.5005ZM37.6565 29.1567C36.144 30.6692 34.1378 31.5005 32.0003 31.5005C29.8628 31.5005 27.8565 30.6692 26.344 29.1567C25.5892 28.4059 24.9929 27.5112 24.5903 26.5257C24.1877 25.5401 23.9871 24.4838 24.0003 23.4192C24.019 21.3692 24.8378 19.388 26.269 17.9192C27.769 16.3817 29.7753 15.5255 31.919 15.5005C34.0378 15.4817 36.094 16.3067 37.6065 17.788C39.1565 19.3067 40.0065 21.338 40.0065 23.5005C40.0003 25.638 39.169 27.6442 37.6565 29.1567Z"
      fill="#9B9B9B"
    />
  </svg>
);
const InstantRewards = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#9B9B9B"
      opacity="0.1"
      d="M53.3203 36.9141H82.4219V47.0703H53.3203V36.9141ZM22.2656 53.7109H46.6797V83.7891H22.2656V53.7109ZM17.5781 36.9141H46.6797V47.0703H17.5781V36.9141ZM53.3203 53.7109H77.7344V83.7891H53.3203V53.7109Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#9B9B9B"
      d="M85.9375 30.2734H71.5234C72.8516 28.1836 73.6328 25.7031 73.6328 23.0469C73.6328 15.6152 67.5879 9.57031 60.1562 9.57031C56.1133 9.57031 52.4707 11.3672 50 14.1992C47.5293 11.3672 43.8867 9.57031 39.8438 9.57031C32.4121 9.57031 26.3672 15.6152 26.3672 23.0469C26.3672 25.7031 27.1387 28.1836 28.4766 30.2734H14.0625C12.334 30.2734 10.9375 31.6699 10.9375 33.3984V52.9297C10.9375 53.3594 11.2891 53.7109 11.7188 53.7109H15.625V87.3047C15.625 89.0332 17.0215 90.4297 18.75 90.4297H81.25C82.9785 90.4297 84.375 89.0332 84.375 87.3047V53.7109H88.2812C88.7109 53.7109 89.0625 53.3594 89.0625 52.9297V33.3984C89.0625 31.6699 87.666 30.2734 85.9375 30.2734ZM46.6797 83.7891H22.2656V53.7109H46.6797V83.7891ZM46.6797 47.0703H17.5781V36.9141H46.6797V47.0703ZM46.6797 29.8828H39.8438C36.0742 29.8828 33.0078 26.8164 33.0078 23.0469C33.0078 19.2773 36.0742 16.2109 39.8438 16.2109C43.6133 16.2109 46.6797 19.2773 46.6797 23.0469V29.8828ZM53.3203 23.0469C53.3203 19.2773 56.3867 16.2109 60.1562 16.2109C63.9258 16.2109 66.9922 19.2773 66.9922 23.0469C66.9922 26.8164 63.9258 29.8828 60.1562 29.8828H53.3203V23.0469ZM77.7344 83.7891H53.3203V53.7109H77.7344V83.7891ZM82.4219 47.0703H53.3203V36.9141H82.4219V47.0703Z"
    />
  </svg>
);
const Rewards = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.0372 29.8808C32.0184 33.7496 28.8684 36.8871 24.9997 36.8871C21.1309 36.8871 17.9809 33.7496 17.9621 29.8808V29.8496C17.9621 25.9683 21.1184 22.8121 24.9997 22.8121C28.8809 22.8121 32.0372 25.9683 32.0372 29.8496V29.8808ZM28.0122 29.8496C28.0122 28.1808 26.6622 26.8308 24.9997 26.8308C23.3372 26.8308 21.9872 28.1871 21.9872 29.8496C21.9872 31.5183 23.3372 32.8683 24.9997 32.8683C26.6622 32.8683 28.0122 31.5121 28.0122 29.8496Z"
      fill="#9B9B9B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.78089 45.937C5.27464 45.937 4.84964 45.5558 4.78089 45.062L0.00589387 8.77452V8.73702C-0.0191061 8.33702 0.424644 8.06827 0.768394 8.28077L12.9371 15.7745L24.5934 0.218268C24.6403 0.155657 24.7012 0.104835 24.7711 0.0698309C24.8411 0.0348265 24.9183 0.0166016 24.9965 0.0166016C25.0748 0.0166016 25.1519 0.0348265 25.2219 0.0698309C25.2919 0.104835 25.3527 0.155657 25.3996 0.218268L37.0621 15.7745L49.2246 8.28077C49.5746 8.06827 50.0121 8.34327 49.9934 8.74327V8.77452L45.2184 45.062C45.1559 45.562 44.7246 45.937 44.2246 45.937H5.78089ZM24.9996 6.80577L14.0184 21.4558L5.28089 16.0745L8.64339 41.662H41.3496L44.7184 16.0745L35.9809 21.4558L24.9996 6.80577Z"
      fill="#9B9B9B"
    />
  </svg>
);
const Stamps = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 46 57"
    fill=""
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2027 1.42734L43.6527 14.8773C44.0277 15.2523 44.2402 15.7648 44.2402 16.2961V31.9373C43.3455 29.7412 41.754 27.9031 39.7402 26.6977V21.4648H26.2402C25.544 21.4648 24.8764 21.1883 24.3841 20.696C23.8918 20.2037 23.6152 19.536 23.6152 18.8398V5.33984H22.6402V5.31984H6.00023V5.33984H4.74023V52.3398H18.1602V56.8398H2.24023C1.13398 56.8398 0.240234 55.9461 0.240234 54.8398V2.83984C0.240234 1.73359 1.13398 0.839844 2.24023 0.839844H28.7902C29.3215 0.839844 29.8277 1.05234 30.2027 1.42734ZM27.8652 17.2148H39.6277L27.8652 5.45234V17.2148Z"
      fill="#9B9B9B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.0002 45.3898H45.0002C45.5502 45.3898 46.0002 45.8398 46.0002 46.3898V55.8898C46.0002 56.4398 45.5502 56.8898 45.0002 56.8898H23.0002C22.4502 56.8898 22.0002 56.4398 22.0002 55.8898V46.3898C22.0002 45.8398 22.4502 45.3898 23.0002 45.3898H32.0002V43.1023C29.1065 42.2398 27.0002 39.5586 27.0002 36.3898C27.0002 32.5211 30.1315 29.3898 34.0002 29.3898C37.869 29.3898 41.0002 32.5211 41.0002 36.3898C41.0002 39.5648 38.894 42.2398 36.0002 43.1023V45.3898ZM34.0002 33.2648C32.2752 33.2648 30.8752 34.6648 30.8752 36.3898C30.8752 38.1148 32.2752 39.5148 34.0002 39.5148C35.7252 39.5148 37.1252 38.1148 37.1252 36.3898C37.1252 34.6648 35.7252 33.2648 34.0002 33.2648ZM25.8752 49.2648V53.0148H42.1252V49.2648H25.8752Z"
      fill="#9B9B9B"
    />
    <path
      d="M33.3595 25.1889C32.3035 23.9929 30.7596 23.2398 29.0402 23.2398C25.8591 23.2398 23.2802 25.8187 23.2802 28.9998C23.2802 30.0716 23.5725 31.0742 24.082 31.9334C25.6068 28.1953 29.1504 25.495 33.3595 25.1889Z"
      fill="#9B9B9B"
    />
    <path
      d="M14.3202 20.6798C17.5014 20.6798 20.0802 18.101 20.0802 14.9198C20.0802 11.7387 17.5014 9.15984 14.3202 9.15984C11.1391 9.15984 8.56023 11.7387 8.56023 14.9198C8.56023 18.101 11.1391 20.6798 14.3202 20.6798Z"
      fill="#9B9B9B"
    />
    <path
      d="M14.3202 34.7598C17.5014 34.7598 20.0802 32.181 20.0802 28.9998C20.0802 25.8187 17.5014 23.2398 14.3202 23.2398C11.1391 23.2398 8.56023 25.8187 8.56023 28.9998C8.56023 32.181 11.1391 34.7598 14.3202 34.7598Z"
      fill="#9B9B9B"
    />
    <path
      d="M13.4242 43.9758H11.2226C11.165 43.9758 11.1202 43.9182 11.1202 43.8478V42.3118C11.1202 42.2414 11.165 42.1838 11.2226 42.1838H13.4242V39.9822C13.4242 39.9246 13.4818 39.8798 13.5522 39.8798H15.0882C15.1586 39.8798 15.2162 39.9246 15.2162 39.9822V42.1838H17.4146C17.4754 42.1838 17.5202 42.2414 17.5202 42.3118V43.8478C17.5202 43.9182 17.4754 43.9758 17.4178 43.9758H15.2162V46.1742C15.2162 46.235 15.1586 46.2798 15.0882 46.2798H13.5522C13.4818 46.2798 13.4242 46.235 13.4242 46.1774V43.9758Z"
      fill="#9B9B9B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7202 43.0798C20.7202 46.6145 17.8549 49.4798 14.3202 49.4798C10.7856 49.4798 7.92023 46.6145 7.92023 43.0798C7.92023 39.5452 10.7856 36.6798 14.3202 36.6798C17.8549 36.6798 20.7202 39.5452 20.7202 43.0798ZM18.8002 43.0798C18.8002 45.5541 16.7945 47.5598 14.3202 47.5598C11.846 47.5598 9.84024 45.5541 9.84024 43.0798C9.84024 40.6056 11.846 38.5998 14.3202 38.5998C16.7945 38.5998 18.8002 40.6056 18.8002 43.0798Z"
      fill="#9B9B9B"
    />
  </svg>
);
const Survey = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 52 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2027 1.42734L43.6527 14.8773C44.0277 15.2523 44.2402 15.7648 44.2402 16.2961V28.2471L39.7402 32.7387V21.4648H26.2402C25.544 21.4648 24.8764 21.1883 24.3841 20.696C23.8918 20.2037 23.6152 19.536 23.6152 18.8398V5.33984H4.74023V52.3398H22.9948L22.9229 56.8398H2.24023C1.13398 56.8398 0.240234 55.9461 0.240234 54.8398V2.83984C0.240234 1.73359 1.13398 0.839844 2.24023 0.839844H28.7902C29.3215 0.839844 29.8277 1.05234 30.2027 1.42734ZM39.6277 17.2148L27.8652 5.45234V17.2148H39.6277Z"
      fill="#9B9B9B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.2896 50.8068L25.2003 56.398C25.1956 56.8166 25.5341 57.1598 25.9526 57.1598H25.9715L31.5202 57.0235C31.6142 57.0188 31.7082 56.9811 31.7741 56.9153L51.3309 37.3999C51.4767 37.2541 51.4767 37.0143 51.3309 36.8685L45.486 31.028C45.4107 30.9528 45.3167 30.9198 45.2179 30.9198C45.1192 30.9198 45.0251 30.9575 44.9499 31.028L25.3978 50.5434C25.3299 50.6144 25.2912 50.7085 25.2896 50.8068ZM28.2756 51.9165L45.2179 35.011L47.3434 37.1319L30.3916 54.0468L28.2427 54.0985L28.2756 51.9165Z"
      fill="#9B9B9B"
    />
    <path
      d="M12.8372 15.3359L16.2824 10.6518C16.3822 10.5182 16.5418 10.4367 16.7081 10.4399H18.5338C18.7499 10.4399 18.8763 10.6812 18.7499 10.8539L13.2629 18.3088C13.2139 18.3754 13.1495 18.4297 13.0749 18.4671C13.0003 18.5045 12.9177 18.5241 12.8339 18.5241C12.7501 18.5241 12.6675 18.5045 12.5929 18.4671C12.5183 18.4297 12.4539 18.3754 12.4049 18.3088L8.61054 13.152C8.48417 12.9792 8.61054 12.738 8.82669 12.738H10.6524C10.822 12.738 10.9816 12.8162 11.0814 12.9531L12.8372 15.3359Z"
      fill="#9B9B9B"
    />
    <path
      d="M12.8372 29.4159L16.2824 24.7318C16.3822 24.5982 16.5418 24.5167 16.7081 24.5199H18.5338C18.7499 24.5199 18.8763 24.7612 18.7499 24.9339L13.2629 32.3888C13.2139 32.4554 13.1495 32.5097 13.0749 32.5471C13.0003 32.5845 12.9177 32.6041 12.8339 32.6041C12.7501 32.6041 12.6675 32.5845 12.5929 32.5471C12.5183 32.5097 12.4539 32.4554 12.4049 32.3888L8.61054 27.232C8.48417 27.0592 8.61054 26.818 8.82669 26.818H10.6524C10.822 26.818 10.9816 26.8962 11.0814 27.0331L12.8372 29.4159Z"
      fill="#9B9B9B"
    />
    <path
      d="M35.765 25.1598H21.0355C20.8621 25.1598 20.7202 25.3038 20.7202 25.4798V27.3998C20.7202 27.5758 20.8621 27.7198 21.0355 27.7198H35.765C35.9384 27.7198 36.0802 27.5758 36.0802 27.3998V25.4798C36.0802 25.3038 35.9384 25.1598 35.765 25.1598Z"
      fill="#9B9B9B"
    />
    <path
      d="M35.7649 30.2798H21.0355C20.8621 30.2798 20.7202 30.4238 20.7202 30.5998V32.5198C20.7202 32.6958 20.8621 32.8398 21.0355 32.8398H35.7649C35.9384 32.8398 36.0802 32.6958 36.0802 32.5198V30.5998C36.0802 30.4238 35.9384 30.2798 35.7649 30.2798Z"
      fill="#9B9B9B"
    />
    <path
      d="M21.0355 11.0798H21.685C21.8584 11.0798 22.0002 11.2238 22.0002 11.3998V13.3198C22.0002 13.4958 21.8584 13.6398 21.685 13.6398H21.0355C20.8621 13.6398 20.7202 13.4958 20.7202 13.3198V11.3998C20.7202 11.2238 20.8621 11.0798 21.0355 11.0798Z"
      fill="#9B9B9B"
    />
    <path
      d="M21.0355 16.1998H21.685C21.8584 16.1998 22.0002 16.3438 22.0002 16.5198V18.4398C22.0002 18.6158 21.8584 18.7598 21.685 18.7598H21.0355C20.8621 18.7598 20.7202 18.6158 20.7202 18.4398V16.5198C20.7202 16.3438 20.8621 16.1998 21.0355 16.1998Z"
      fill="#9B9B9B"
    />
    <path
      d="M21.0355 44.3598H21.685C21.8584 44.3598 22.0002 44.5038 22.0002 44.6798V46.5998C22.0002 46.7758 21.8584 46.9198 21.685 46.9198H21.0355C20.8621 46.9198 20.7202 46.7758 20.7202 46.5998V44.6798C20.7202 44.5038 20.8621 44.3598 21.0355 44.3598Z"
      fill="#9B9B9B"
    />
    <path
      d="M12.8372 43.4959L16.2824 38.8118C16.3822 38.6782 16.5418 38.5967 16.7081 38.5999H18.5338C18.7499 38.5999 18.8763 38.8412 18.7499 39.0139L13.2629 46.4688C13.2139 46.5354 13.1495 46.5897 13.0749 46.6271C13.0003 46.6645 12.9177 46.6841 12.8339 46.6841C12.7501 46.6841 12.6675 46.6645 12.5929 46.6271C12.5183 46.5897 12.4539 46.5354 12.4049 46.4688L8.61054 41.312C8.48417 41.1392 8.61054 40.898 8.82669 40.898H10.6524C10.822 40.898 10.9816 40.9762 11.0814 41.1131L12.8372 43.4959Z"
      fill="#9B9B9B"
    />
    <path
      d="M21.0355 39.2398H29.365C29.5384 39.2398 29.6802 39.3838 29.6802 39.5598V41.4798C29.6802 41.6558 29.5384 41.7998 29.365 41.7998H21.0355C20.8621 41.7998 20.7202 41.6558 20.7202 41.4798V39.5598C20.7202 39.3838 20.8621 39.2398 21.0355 39.2398Z"
      fill="#9B9B9B"
    />
  </svg>
);

const Raffle = props => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.988 22.2363H13.0288V25.6649H14.988V22.2363Z" fill="#9B9B9B" stroke="#9B9B9B" />
    <path d="M14.988 28.1152H13.0288V31.5438H14.988V28.1152Z" fill="#9B9B9B" stroke="#9B9B9B" />
    <path d="M14.9877 34.0898H13.0286V37.5184H14.9877V34.0898Z" fill="#9B9B9B" stroke="#9B9B9B" />
    <path d="M14.988 39.9668H13.0288V43.3954H14.988V39.9668Z" fill="#9B9B9B" stroke="#9B9B9B" />
    <path
      d="M15.5754 1.56641L10.5795 9.5011L11.2652 10.0889C13.2244 11.5582 13.7142 14.3011 12.3428 16.3582C11.0693 18.4154 8.42439 19.1991 6.26929 18.0235L5.48561 17.6317L4.89786 18.6113H0.979492V28.0154L1.86112 28.1133C4.3101 28.3093 6.17133 30.3664 6.17133 32.8154C6.17133 35.2644 4.3101 37.3215 1.86112 37.5174L0.979492 37.6154V47.0195H46.0407V37.6154L45.1591 37.5174C43.5917 37.3215 42.1223 36.3419 41.4366 34.8725C41.1428 34.1868 40.9468 33.5011 40.9468 32.8154C40.9468 30.3664 42.8081 28.3093 45.1591 28.1133L46.0407 28.0154V18.6113H42.7101L15.5754 1.56641ZM14.106 17.4358C15.7713 14.7909 15.3795 11.3623 13.2244 9.20722L16.2611 4.30926L38.9877 18.6113H21.453L22.3346 17.1419L20.6693 16.0644L19.1999 18.6113H13.1264C13.4203 18.2195 13.8121 17.8276 14.106 17.4358ZM44.0815 26.3501C41.1428 27.0358 38.8897 29.6807 38.8897 32.8154C38.8897 33.795 39.0856 34.8725 39.5754 35.7542C40.457 37.5174 42.1224 38.8889 43.9836 39.2807V45.0603H2.93868V39.2807C5.97541 38.595 8.13051 35.9501 8.13051 32.8154C8.13051 29.6807 5.97541 27.0358 2.93868 26.3501V20.5705H3.62439H44.0815V26.3501Z"
      fill="#9B9B9B"
      stroke="#9B9B9B"
    />
    <path
      d="M23.9245 11.0433L22.1018 13.9473L23.7612 14.9888L25.5839 12.0848L23.9245 11.0433Z"
      fill="#9B9B9B"
      stroke="#9B9B9B"
    />
  </svg>
);

const InstantReward = props => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#9B9B9B"
      fillRule="evenodd"
      clipRule="evenodd"
      opacity="0.1"
      d="M53.3203 36.9141H82.4219V47.0703H53.3203V36.9141ZM22.2656 53.7109H46.6797V83.7891H22.2656V53.7109ZM17.5781 36.9141H46.6797V47.0703H17.5781V36.9141ZM53.3203 53.7109H77.7344V83.7891H53.3203V53.7109Z"
    />
    <path
      fill="#9B9B9B"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.9375 30.2734H71.5234C72.8516 28.1836 73.6328 25.7031 73.6328 23.0469C73.6328 15.6152 67.5879 9.57031 60.1562 9.57031C56.1133 9.57031 52.4707 11.3672 50 14.1992C47.5293 11.3672 43.8867 9.57031 39.8438 9.57031C32.4121 9.57031 26.3672 15.6152 26.3672 23.0469C26.3672 25.7031 27.1387 28.1836 28.4766 30.2734H14.0625C12.334 30.2734 10.9375 31.6699 10.9375 33.3984V52.9297C10.9375 53.3594 11.2891 53.7109 11.7188 53.7109H15.625V87.3047C15.625 89.0332 17.0215 90.4297 18.75 90.4297H81.25C82.9785 90.4297 84.375 89.0332 84.375 87.3047V53.7109H88.2812C88.7109 53.7109 89.0625 53.3594 89.0625 52.9297V33.3984C89.0625 31.6699 87.666 30.2734 85.9375 30.2734ZM46.6797 83.7891H22.2656V53.7109H46.6797V83.7891ZM46.6797 47.0703H17.5781V36.9141H46.6797V47.0703ZM46.6797 29.8828H39.8438C36.0742 29.8828 33.0078 26.8164 33.0078 23.0469C33.0078 19.2773 36.0742 16.2109 39.8438 16.2109C43.6133 16.2109 46.6797 19.2773 46.6797 23.0469V29.8828ZM53.3203 23.0469C53.3203 19.2773 56.3867 16.2109 60.1562 16.2109C63.9258 16.2109 66.9922 19.2773 66.9922 23.0469C66.9922 26.8164 63.9258 29.8828 60.1562 29.8828H53.3203V23.0469ZM77.7344 83.7891H53.3203V53.7109H77.7344V83.7891ZM82.4219 47.0703H53.3203V36.9141H82.4219V47.0703Z"
    />
  </svg>
);
const Streak = props => (
  <svg
    height="50"
    width="50"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    id="repeat_bold"
    {...props}
  >
    <path
      d="M38.243 28.251c-.006-.011-.016-.018-.022-.028-.027-.049-.066-.087-.101-.13-.044-.055-.086-.111-.14-.154-.039-.032-.084-.052-.128-.078a.952.952 0 0 0-.207-.097c-.019-.006-.033-.02-.052-.025-.035-.009-.068 0-.102-.005a.919.919 0 0 0-.403.025c-.027.008-.055.004-.082.015l-5.647 2.108a.999.999 0 1 0 .7 1.873l3.688-1.376c-1.844 4.298-6.017 7.159-10.737 7.159-5.338 0-10.006-3.686-11.35-8.964a1 1 0 1 0-1.939.494c1.57 6.164 7.034 10.47 13.288 10.47 5.497 0 10.359-3.306 12.533-8.279l1.793 3.484a.998.998 0 0 0 1.347.431 1 1 0 0 0 .432-1.347l-2.871-5.576zM25.008 13.536c5.164 0 9.664 3.386 11.199 8.426a1 1 0 0 0 1.913-.582c-1.793-5.888-7.063-9.844-13.112-9.844-5.269 0-9.939 2.998-12.244 7.658l-1.637-3.438a1 1 0 1 0-1.806.859l2.622 5.504c.004.009.011.015.015.023.012.023.029.042.043.065a.98.98 0 0 0 .248.275c.087.065.181.119.284.153.008.003.014.01.023.012l.007.001a.994.994 0 0 0 .283.042h.003a.992.992 0 0 0 .263-.036l5.698-1.572a.999.999 0 1 0-.532-1.927l-3.78 1.043c1.952-4.05 5.973-6.662 10.51-6.662z"
      transform="rotate(45 25 25)"
      fill="#9B9B9B"
      stroke="#9B9B9B"
      stroke-width="1.5"
      stroke-linejoin="round"
    ></path>
  </svg>
);
export {
  Games,
  Points,
  Quest,
  Quiz,
  Referral,
  Rewards,
  Stamps,
  Survey,
  InstantReward,
  Progress,
  Raffle,
  InstantRewards,
  Streak
};
